"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalDetailsForm = exports.PERSONAL_DETAILS_FORM_NAME = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const common_types_1 = require("@as-react/common-types");
const andes_react_1 = require("@yonderland/andes-react");
const yup_1 = require("@hookform/resolvers/yup");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const Yup = require("yup");
const dayjs = require("dayjs");
const jsvat_next_1 = require("jsvat-next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const TitleField_1 = require("../../form/registration-fields/TitleField");
const CheckoutContext_1 = require("../../../context/CheckoutContext");
const customParseFormat = require("dayjs/plugin/customParseFormat");
const isBetween = require("dayjs/plugin/isBetween");
const InvoiceFields_1 = require("../../form/registration-fields/InvoiceFields");
const CustomerDetailsFields_1 = require("../../form/registration-fields/CustomerDetailsFields");
const AddressFields_1 = require("../../form/registration-fields/AddressFields");
const CountryUtil_1 = require("../../../util/CountryUtil");
const AddressUtil_1 = require("../../../util/AddressUtil");
const NewsLetterField_1 = require("../../form/registration-fields/NewsLetterField");
const CountryChangeWatcher_1 = require("../../form/registration-fields/watchers/CountryChangeWatcher");
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
exports.PERSONAL_DETAILS_FORM_NAME = 'personal-details-form';
const PersonalDetailsForm = ({ onSubmit, errorFeedback, isLoading, }) => {
    const { t } = (0, react_i18next_1.useTranslation)([
        i18nConstants_1.I18N_NAMESPACES.account,
        i18nConstants_1.I18N_NAMESPACES.checkout,
        i18nConstants_1.I18N_NAMESPACES.general,
        i18nConstants_1.I18N_NAMESPACES.navigation,
    ]);
    const { market, fictiveWebShop, lang } = (0, common_components_1.useAemConfig)();
    const defaultCountryCode = (0, CountryUtil_1.getCountryByFictiveWebShop)(fictiveWebShop);
    const [activeCountry, setActiveCountry] = (0, react_1.useState)();
    const showMiddleName = market === 'nl' || (activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.idCountry) === common_types_1.CountryId.NL;
    const { registrationForm: { showInvoiceCheckbox, showAddress, showNewsletterCheckbox, sectionTitle }, } = (0, CheckoutContext_1.useCheckoutConfig)();
    const validationSchema = Yup.object({
        title: Yup.number().required(t(common_types_1.ErrorMessage.ACCOUNT_REQUIRED)),
        gender: Yup.string().required(t(common_types_1.ErrorMessage.ACCOUNT_REQUIRED)),
        firstName: Yup.string().required(t(common_types_1.ErrorMessage.ACCOUNT_REQUIRED)),
        lastName: Yup.string().required(t(common_types_1.ErrorMessage.ACCOUNT_REQUIRED)),
        middleName: Yup.string(),
        mobilePhoneNumber: Yup.string().test('phoneNumber', t(common_types_1.ErrorMessage.INVALID_PHONE), val => !val || (0, andes_react_1.isPossiblePhoneNumber)(val)),
        dateOfBirth: Yup.string().test('checkDateOfBirth', t(common_types_1.ErrorMessage.INVALID_DATE), (val = '') => {
            if (!val)
                return true;
            const isDateValid = dayjs(val, 'DD/MM/YYYY', true).isValid();
            if (!isDateValid)
                return false;
            return dayjs(val, 'DD/MM/YYYY').isBetween(dayjs().subtract(100, 'year'), dayjs().subtract(11, 'year'), 'year');
        }),
        invoice: Yup.boolean(),
        finance: Yup.object().when('invoice', {
            is: true,
            then: () => Yup.object({
                vatNumber: Yup.string()
                    .required(t(common_types_1.ErrorMessage.ACCOUNT_REQUIRED))
                    .test('checkVAT', t(common_types_1.ErrorMessage.INVALID_VAT_NUMBER), value => {
                    const currentCountry = (activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode)
                        ? jsvat_next_1.countries.find(item => item.codes.includes(activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode))
                        : undefined;
                    return currentCountry ? (0, jsvat_next_1.checkVAT)(value, [currentCountry]).isValid : false;
                }),
                companyName: Yup.string().required(t(common_types_1.ErrorMessage.ACCOUNT_REQUIRED)),
                departmentName: Yup.string(),
            }),
        }),
        address: Yup.object().when('invoice', {
            is: true,
            then: () => (0, AddressUtil_1.getAddressValidationSchema)({ country: activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode, t, isOptional: false }),
            otherwise: () => (0, AddressUtil_1.getAddressValidationSchema)({ country: activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode, t, isOptional: true }),
        }),
        addressSearch: Yup.object().when('invoice', {
            is: true,
            then: () => (0, AddressUtil_1.getAddressSearchValidationSchema)({ country: activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode, t, isOptional: false }),
            otherwise: () => (0, AddressUtil_1.getAddressSearchValidationSchema)({ country: activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode, t, isOptional: true }),
        }),
        newsletter: Yup.boolean(),
    });
    const formProps = (0, react_hook_form_1.useForm)({
        defaultValues: {
            title: undefined,
            gender: '',
            invoice: false,
            firstName: '',
            lastName: '',
            finance: {
                vatNumber: '',
                companyName: '',
                departmentName: '',
            },
            middleName: '',
            dateOfBirth: '',
            mobilePhoneNumber: '',
            newsletter: false,
            address: Object.assign(Object.assign({}, AddressUtil_1.emptyAddress), { finder: '', idCountry: common_types_1.CountryId[defaultCountryCode.toUpperCase()] }),
            addressSearch: {
                postCode: '',
                houseNumber: '',
            },
        },
        mode: 'onTouched',
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const handleSubmit = values => {
        const country = (activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryDescriptionTranslations[lang.toUpperCase()]) || '';
        onSubmit(Object.assign(Object.assign({}, values), { address: Object.assign(Object.assign({}, values.address), { country }) }));
    };
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, Object.assign({}, formProps, { children: (0, jsx_runtime_1.jsx)("form", { name: exports.PERSONAL_DETAILS_FORM_NAME, noValidate: true, children: (0, jsx_runtime_1.jsxs)(andes_react_1.StackBlock, { gap: "6", children: [sectionTitle && ((0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "headingS", color: "emphasised", children: sectionTitle })), errorFeedback && (0, jsx_runtime_1.jsx)(andes_react_1.Banner, { text: errorFeedback, status: "error" }), (0, jsx_runtime_1.jsx)(TitleField_1.TitleField, {}), (0, jsx_runtime_1.jsx)(CustomerDetailsFields_1.CustomerDetailsFields, { showMiddleName: showMiddleName }), showAddress && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(andes_react_1.Divider, {}), (0, jsx_runtime_1.jsx)(AddressFields_1.AddressFields, { country: activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode, onCountryChange: setActiveCountry })] })), showInvoiceCheckbox && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(andes_react_1.Divider, {}), (0, jsx_runtime_1.jsx)(InvoiceFields_1.InvoiceFields, { country: activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode, onCountryChange: setActiveCountry })] })), showNewsletterCheckbox && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(andes_react_1.Divider, {}), (0, jsx_runtime_1.jsx)(NewsLetterField_1.NewsLetterField, {})] })), (activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode) && ((0, jsx_runtime_1.jsx)(CountryChangeWatcher_1.CountryChangeWatcher, { countryIdFieldName: "address.idCountry", fieldPrefix: "address.", vatNumberFieldName: "finance.vatNumber" })), (0, jsx_runtime_1.jsx)(andes_react_1.CheckoutLayout.Sticky, { children: (0, jsx_runtime_1.jsx)(andes_react_1.Grid, { columns: 12, children: (0, jsx_runtime_1.jsx)(andes_react_1.Grid.Cell, { span: { xs: 12, lg: 4 }, offset: { lg: 9 }, children: (0, jsx_runtime_1.jsx)(andes_react_1.ButtonAlpha, { type: "submit", theme: "branded", state: isLoading ? 'loading' : 'interactive', text: t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.personal.details.submit`), fullWidth: true, onClick: formProps.handleSubmit(handleSubmit) }) }) }) })] }) }) })));
};
exports.PersonalDetailsForm = PersonalDetailsForm;
